import types from "./actionTypes";

class LoaderActions {
    static startAsyncCall() {
        return {
            type: types.START_ASYNC_CALL
        };
    }

    static errorAsyncCall() {
        return {
            type: types.ERROR_ASYNC_CALL
        };
    }
}
export default LoaderActions;
